import { Product } from '../types';

export const projects: Product[] = [
  // Products for sale / lead generation
  {
    id: '1',
    title: 'Phonetic Pro Text Converter',
    description: 'Convert text to phonetic alphabets in real-time using various international standards. Now fully integrated with new features.',
    image: 'https://lh3.googleusercontent.com/2ovsA-WyyujYuAy2wCvr6hvLxWbuluyw_YfWTW21Vr9jSdAmpjI9js5cyPlvlNYG-THDjR39eR47OZQEtCuGNE_ixQ=s1280-w1280-h800',
    url: '/portfolio/phonetic',
    category: 'chrome',
    featured: true,
    isPortfolio: false,
    tags: ['Extension', 'Productivity', 'Communication'],
    stats: {
      users: 50,
      downloads: 70
    }
  },
  {
    id: 'local-route',
    title: 'Local Route',
    description: 'Launch URLs at Lightning Speed. Organize bookmarks, use fuzzy search, and navigate your favorite sites with keyboard shortcuts.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=800',
    url: '/portfolio/local-route',
    category: 'chrome',
    featured: true,
    isPortfolio: false,
    tags: ['Productivity', 'Browser Tool', 'Utility'],
    stats: {
      users: 100,
      downloads: 200
    }
  },
  {
    id: '2',
    title: 'SecureForFree.com',
    description: 'A comprehensive SaaS platform providing essential security tools and resources. Empowering users with robust security solutions through an intuitive interface.',
    image: '/assets/projects/secureforfree.com-project.png',
    url: 'https://secureforfree.com',
    category: 'saas',
    featured: true,
    isPortfolio: false,
    tags: ['Security', 'SaaS', 'Tools'],
    stats: {
      users: 50
    }
  },
  {
    id: '3',
    title: 'Sellerbase.eu',
    description: 'Connect & Scale Your E-commerce Empire. A comprehensive platform where sellers meet, discuss, read blogs, and access powerful tools for growth.',
    image: '/assets/projects/sellerbase.eu-project.png',
    url: 'https://sellerbase.eu',
    category: 'saas',
    featured: true,
    isPortfolio: false,
    tags: ['E-commerce', 'Community', 'Business Tools'],
    stats: {
      users: 100
    }
  },
  // Free Tools
  {
    id: 'buymegift',
    title: 'BuyMeGift.com',
    description: 'Share your Allegro shopping cart with friends and family. Simple, fast, secure. No registration required, ready instantly.',
    image: 'https://www.buymegift.com/logo.png',
    url: 'https://buymegift.com',
    category: 'saas',
    featured: true,
    isPortfolio: false,
    tags: ['E-commerce', 'Sharing', 'Utility'],
  },
  {
    id: 'airsend',
    title: 'AirSend.app',
    description: 'Share files instantly between any devices - Windows, Mac, Android, iOS, Linux. 5GB free forever with military-grade encryption.',
    image: 'https://www.airsend.app/airship-astronout.png',
    url: 'https://airsend.app',
    category: 'saas',
    featured: true,
    isPortfolio: false,
    tags: ['File Sharing', 'Cross-Platform', 'Security'],
  },
  // Portfolio showcase projects
  {
    id: '4',
    title: 'AtesITSolutions.com',
    description: 'We provide creative, unique, and specialized digital marketing solutions that ensure your investments lead to tangible results. Unrivaled Experience.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=800',
    url: 'https://atesitsolutions.com',
    category: 'webdesign',
    featured: true,
    isPortfolio: true,
    tags: ['Business', 'Web Design'],
  },
  {
    id: '5',
    title: 'EmelKedik.com',
    description: 'A dynamic platform showcasing engaging YouTube vlogs and an automated Ghost-powered blog. Designed to seamlessly deliver fresh content, keeping audiences connected and inspired.',
    image: '/assets/projects/emelkedik.com-project.png',
    url: 'https://emelkedik.com',
    category: 'webdesign',
    featured: true,
    isPortfolio: true,
    tags: ['Business', 'Web Design'],
  },
  {
    id: 'istanbulbarbershop',
    title: 'Istanbul Barbershop',
    description: 'Stylowe strzyżenie i pielęgnacja. Łączymy tureckie tradycje fryzjerskie z nowoczesnymi technikami, oferując usługi najwyższej jakości w Warszawie.',
    image: 'https://media.swipepages.com/2024/10/670eb19c08e40f00114a38b3/istanbul_logo-750.webp',
    url: 'https://www.istanbulbarbershop.pl/',
    category: 'webdesign',
    featured: true,
    isPortfolio: true,
    tags: ['Business', 'Web Design', 'Local'],
  },
  {
    id: 'multioutlet',
    title: 'Multioutlet.com.pl',
    description: 'Outlet Warszawa - szeroki wybór zegarków, torebek, odzieży i mebli w niskich cenach. Gwarancja najniższej ceny i darmowa wysyłka.',
    image: 'https://multioutlet.com.pl/wp-content/uploads/2025/01/home-zegarek-w-multioutlet-2025.jpg',
    url: 'https://www.multioutlet.com.pl/',
    category: 'ecommerce',
    featured: true,
    isPortfolio: true,
    tags: ['E-commerce', 'Retail', 'Web Design'],
  },
  {
    id: 'eneskebab',
    title: "Enes Kebab",
    description: 'Authentic Turkish Kebab restaurant in Poland, focusing on fresh ingredients and traditional recipes for the best döner experience.',
    image: 'https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?auto=format&fit=crop&q=80&w=800',
    url: 'https://www.eneskebab.pl/',
    category: 'webdesign',
    featured: true,
    isPortfolio: true,
    tags: ['Restaurant', 'Web Design', 'Local'],
  }
];
